/* eslint-disable @stylistic/comma-dangle */

import { sharedLocale }	from "@geotoura/shared/sharedLocale_it";
import { siteInfo }		from "@geotoura/shared/siteInfo_it";
import { Title }		from "@geotoura/shared/commonModel";

export const messages = {
	form: {
		fieldRequired:		"Questo campo è obbligatorio.",
		fieldInvalid:		"Il valore di questo campo non è valido.",
		privacyAgreement:	sharedLocale.privacyAgreement,
		title: {
			label:	"Titel",
			choices: [
				Title.brand("Dott."),
				Title.brand("Dotta."),
				Title.brand("Prof."),
				Title.brand("Prof.ssa"),
				Title.brand("Prof. Dott."),
				Title.brand("Prof.ssa Dott.ssa"),
			],
		},
		gender:		{
			label:		"Genere",
			choices:	{
				u:	"",
				m:	"maschile",
				w:	"femminile",
				d:	"altro"
			},
		},
		firstName:	"Nome",
		lastName:	"Cognome",
		email: {
			label:			"E-mail",
			placeholder:	"Il tuo indirizzo e-mail",
		},
		phone: {
			label:			"Telefono",
			placeholder:	"Il tuo numero di telefono",
		},
	},
	privacy: {
		title:	"Le impostazioni dei Cookie",
		intro:	{
			pre:	"Oltre ai cookie che sono tecnicamente necessari, utilizziamo i cookie per analizzare l’uso del nostro sito web. Nell'ambito delle statistiche e del marketing, noi e il nostro partner svolgiamo i seguenti processi di trattamento dei dati: pubblicità e contenuti personalizzati, misurazione e performance di annunci e contenuti, nonché memorizzazione o accesso alle informazioni su un dispositivo tramite cookie tecnici. Potete ritirare il consenso al loro utilizzo qui o tramite la nostra ",
			link:	{
				href:	siteInfo.page.privacy,
				text:	"pagina sulla protezione dei dati"
			},
			post:	"in qualsiasi momento."
		},
		essential:	"Cookie tecnici",
		nonessential:	{
			pre:	"Statistica e Marketing (",
			link:	{
				href:	siteInfo.page.privacy,
				text:	"Ulteriori informazioni"
			},
			post:	")",
		},
		saveSettings:	"Salvare le impostazioni",
		acceptAll:		"Accettare tutto",
		imprint:	{
			pre:	"",
			link:	{
				href:	siteInfo.page.impressum,
				text:	"Note legali"
			},
			post:	"",
		},
	},
};
